module.exports = __webpack_public_path__ + "img/emma-zoekt-2.d6dde6e9.svg";